React = require 'react/addons'
AgeProtectedRoute = require '../mixins/age-protected-route'
VideoStore = require '../stores/video-store'
Router = require 'react-router'
Link = Router.Link
AnimateScroll = require '../mixins/animate-scroll'
LightMode = require '../mixins/light-mode'

module.exports = React.createClass
  displayName: 'Home'
  mixins: [AgeProtectedRoute, AnimateScroll, LightMode]

  render: ->
    React.createElement("div", {"className": 'word-list-wrap'},
      React.createElement("ul", {"className": 'word-list'},
      (
        React.createElement("li", {"key": (item.key)}, React.createElement(Link, {"to": 'video', "params": ( videoId: item.name )}, (item.title))) for item in VideoStore.videos
      )
      )
    )



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/home.cjsx
 **/